<template>

    <main class="temoignages-body-template">
        <article>
            <section class="text-right">
                <figure>
                    <img class="picture" v-if="item.picture" :src="require('../../assets/' + item.picture)" alt="">
                    <figcaption>
                        <p style="color : #A2C038">NICOLAS CARLÉSI</p>
                        <p class="green">COMPANY DIRECTOR

 <br />IN ROQUEFORT-LA-BEDOULE (13)</p>
                    </figcaption>
                </figure>

                <p class="number" :class="item.color">
                    7
                </p>
                <p class="green uppercase semiBold">
                   7 startups that could form the nucleus of tomorrow’s insurance industry have been selected for inclusion in the FrenchTech accelerator partnered by Groupama Centre-Atlantique.
                </p>

                <img class="icono w96" :src="require('../../assets/fleuro.svg')">
                <p class="label green">
                   EMPLOYEE SAVINGS 
                </p>

                <p class="green uppercase semiBold">
                    Groupama Épargne Salariale<br> has launched the  <span class="marker" :class="item.color">iGES</span>,<br> online application service <br>for all its employee savings schemes.
                </p>

				 <img class="icono w300" :src="require('../../assets/gan.jpg')">
                <p class="label green">
                    MULTIRISQUES ESSENTIELS
                </p>

                <p class="green uppercase semiBold">
                   A new multi-risk product from<br>Gan Assurances tailored to the needs <br>of individual business sectors.

                </p>
            </section>

            <section>
                <svg class="quote" :class="item.color" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.8 42.61">
                    <path d="M59.8,0H45.59C39,11,34.91,18,33.43,20.83a17.92,17.92,0,0,0-2.17,8.26c0,7.57,6.36,13.52,14.34,13.52s14.2-6,14.2-13.52c0-5.28-2.7-9.2-8.11-11.5ZM28.55,0H14.21C7.57,11.09,3.65,18.13,2.16,21A17.49,17.49,0,0,0,0,29.09c0,7.57,6.22,13.52,14.2,13.52s14.2-6,14.2-13.52c0-5.28-2.7-9.2-8.11-11.5Z"/>
                </svg>
                <h2>This award has given us real recognition at national level.</h2>
				
                <h1>  
                    <span>Supporting Nicolas</span>
                 
                    <span>and all <em :class="item.color">small and</em></span>
                    <span><em :class="item.color"> medium-sized entreprises</em></span>
                </h1>

                

                <p>
                    Chairman and founder of IADYS in 2016, Nicolas Carlési is passionate about the sea, and has applied his studies in robotics and artificial intelligence to a major environmental cause: cleaning up aquatic environments. Having seen over many years of sailing and diving how the marine environment was suffering, Nicolas had the idea of inventing a compact, lightweight electric robot able to capture waste and hydrocarbons floating on the surface of the water, especially in harbours before they are either dumped at sea or sink to the bottom. 
					<br><br>It was PACI, the Pays d'Aubagne La Ciotat business startup centre, that gave Nicolas the support he needed and encouraged him in 2018 to apply for the Groupama Pro Awards, firstly at departmental level, then at regional level.  <br><br>
                    In 2019, his work was rewarded with the top <span class="marker" :class="item.color">Pro National Award</span>.<br><br>
                    This recognition brought his work to a much wider audience with support from Groupama, generating significant feedback and the first real recognition at a national level, including the production of a video that has generated a tangible level of pride in his 8-person startup. 
 <br>
                    <br>
                  Nicolas feels a particular affinity with the Groupama teams he has met, describing the company as “a Group that works very closely with professionals and understands what is happening in the field”. Values that he shares inside his own company on a daily basis as he launches initiatives that raise awareness of the need for environmental protection. 

                </p>

                <div class="link-content">
                    <p style="margin-top: 30px">Watch the Jellyfishbot demonstration video</p>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/n8XftQFKwhE" frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                </div>
                <a href="" class="link">
                    <svg class="link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 324">
                        <path d="M239,260v56a7.89,7.89,0,0,1-8,8H40A40.12,40.12,0,0,1,0,284V40A40.12,40.12,0,0,1,40,0H242c4,0,8,4,8,8V252a7.89,7.89,0,0,1-8,8Zm-16,16V260H40a23.69,23.69,0,0,0-24,24c0,14,10,24,24,24H223V292H37V276Zm11-31V16H40C26,16,16,26,16,40V253c7-5,14-8,24-8Z"/>
                        <path d="M197,64v61H52V64ZM183,78H67v33H183Z"/>
                    </svg>
                    <div class="link-content">
                        <p>To learn more about the facts that marked our year</p>
                        <p><span>DOWNLOAD</span> THE ANNUAL REPORT</p>
                    </div>
                </a>

            </section>
        </article>
    </main>


</template>

<script>

    export default {
        name: "TemoignageBody",
        props: ['item'],
        mounted() {

            window.removeEventListener('scroll', this.scroll)
            window.addEventListener('scroll', this.scroll)

        },
        methods: {
            scroll() {
                if(!document.querySelector('.temoignages-item-bar.active'))
                    return;

                if (this.isInViewport(document.querySelector('.temoignages-item-bar.active')))
                    document.querySelector('.temoignages-item-bar.active + .temoignages-item-content .close').style.opacity = 0;
                else
                    document.querySelector('.temoignages-item-bar.active + .temoignages-item-content .close').style.opacity = 1;
            },
            isInViewport(elem) {
                let bounding = elem.getBoundingClientRect();
                return (
                    bounding.top >= -document.querySelector('.temoignages-item-bar.active').clientHeight &&
                    bounding.left >= 0 &&
                    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            }
        }
    }
</script>

